import React, { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

function Welcome() {
  const location = useLocation();
  const activeLink = location.pathname;

  return (
    <>
    <header>
      <nav className="bg-black px-4 lg:px-6 py-2.5">
        <div className="flex justify-between items-center mx-auto max-w-screen-xl">
          <Link to="/" className="flex items-center">
            <img src="/img/logo.png" className="mr-3 h-6 sm:h-9" alt="Logo" /> 
          </Link>

       

          <ul className="hidden lg:flex space-x-6">
            <li>
              <Link to="/" className={activeLink === '/' ? 'text-yellow-400' : 'text-white'}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/company" className={activeLink === '/company' ? 'text-yellow-400' : 'text-white'}>
                Company
              </Link>
            </li>
            <li>
              <Link to="/about" className={activeLink === '/about' ? 'text-yellow-400' : 'text-white'}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/pricing" className={activeLink === '/pricing' ? 'text-yellow-400' : 'text-white'}>
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/contact" className={activeLink === '/contact' ? 'text-yellow-400' : 'text-white'}>
                Contact
              </Link>
            </li>

            
          </ul>
          <div className="flex items-center">
            <Link to="/login" className="text-white bg-gray-800 rounded-lg px-4 py-2 mr-2">Login</Link>
            <Link to="/signup" className="text-white bg-gray-800 rounded-lg px-4 py-2 mr-2">Get started</Link>
          </div>
        </div>
        
      </nav>
    </header>
    <div className="p-4 min-h-screen">
        <Outlet /> {/* Child routes (like Company, About) yahin render hote hain */}
      </div>
    </>
  );
}

export default Welcome;
